import { Link } from "react-router-dom";
import { HOME_PAGE, LOGIN_PAGE } from "../../routes/routes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button, TextField, Typography, Grid, Box, Slide } from "@mui/material";
import { selectIsLoading } from "../../redux/state/authReduser/authentification.selectors";
import { registrationUser } from "../../redux/state/authReduser/services";
import Loader from "../../Components/Loader/Loader";
import { useSnackbar } from "notistack";
import { container, title, inputField, button, link } from "./Registr.styles";
import { validationSchema } from "./validationSchema";

const Registr = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [mounted, setMounted] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    try {
      validationSchema.validateSync(formData, { abortEarly: false });
    } catch (err) {
      err.inner.forEach((error) => {
        newErrors[error.path] = error.message;
      });
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      dispatch(
        registrationUser({
          username: formData.username,
          email: formData.email,
          password: formData.password,
        })
      )
        .unwrap()
        .then(() => {
          navigate(HOME_PAGE);
        })
        .catch(() => {
          enqueueSnackbar("Ошибка при регистрации, попробуйте снова", {
            variant: "error",
          });
        });
    } else {
      setErrors(validationErrors);
      Object.values(validationErrors).forEach((error) => {
        enqueueSnackbar(error, { variant: "error" });
      });
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <Slide direction={mounted ? "left" : "right"} in={mounted} timeout={1000}>
        <Box sx={container}>
          <Typography sx={title}>Регистрация</Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  name="username"
                  label="Имя"
                  variant="outlined"
                  fullWidth
                  value={formData.username}
                  onChange={handleChange}
                  error={Boolean(errors.username)}
                  helperText={errors.username}
                  required
                  sx={inputField(errors.username)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="email"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={formData.email}
                  onChange={handleChange}
                  error={Boolean(errors.email)}
                  helperText={errors.email}
                  required
                  sx={inputField(errors.email)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="password"
                  label="Пароль"
                  type="password"
                  variant="outlined"
                  fullWidth
                  value={formData.password}
                  onChange={handleChange}
                  error={Boolean(errors.password)}
                  helperText={errors.password}
                  required
                  sx={inputField(errors.password)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="confirmPassword"
                  label="Подтвердите пароль"
                  type="password"
                  variant="outlined"
                  fullWidth
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  error={Boolean(errors.confirmPassword)}
                  helperText={errors.confirmPassword}
                  required
                  sx={inputField(errors.confirmPassword)}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={button}
                >
                  Зарегистрироваться
                </Button>
              </Grid>
            </Grid>
          </form>

          <Typography
            variant="body2"
            align="center"
            sx={{ ...link, fontSize: "14px" }}
          >
            Уже есть аккаунт?
          </Typography>
          <Link
            to={LOGIN_PAGE}
            style={{
              textDecoration: "none",
              fontWeight: "bold",
              color: "#3f51b5",
              transition: "color 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#1e40a6")}
            onMouseLeave={(e) => (e.target.style.color = "#3f51b5")}
          >
            Войдите
          </Link>
        </Box>
      </Slide>
    </>
  );
};

export default Registr;
